<template>
  <div class="fm-logo" :class="!isCollapse ? 'w250' : 'w65'">
    <transition name="sidebarLogoFade">
      <router-link v-if="!isCollapse" key="collapse" class="fm-logo-link" to="/">
        <div class="fm-brand">
          <span class="fm-brand-title">FreshMon Pulse</span>
          <span class="fm-brand-subtitle">ALWAYS FRESH · ALWAYS IN CONTROL</span>
        </div>
      </router-link>
      <router-link v-else key="expand" class="fm-logo-link" to="/">
        <img :src="logomin" class="fm-logo-min" />
      </router-link>
    </transition>
  </div>
</template>

<script>
import logomin from '@/assets/images/img/app-logo.png'
export default {
  props: {
    isCollapse: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      logomin: logomin
    }
  }
}
</script>

<style lang='scss' scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.fm-logo {
  width: 250px;
  height: 100%;
  display: flex;
  cursor: pointer;
  transition: all 0.5s ease-in-out;
  padding: 2px 0;
  box-sizing: border-box;
}

.fm-logo-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  text-decoration: none;
}

/* 展开状态：文字品牌 */
.fm-brand {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 0 12px;
  box-sizing: border-box;
}

.fm-brand-title {
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0.4px;
  /* 兜底色（深色背景默认），全局主题样式会覆盖 */
  color: #ffffff;
}

.fm-brand-subtitle {
  margin-top: 3px;
  font-size: 8px;
  font-weight: 500;
  line-height: 1.15;
  letter-spacing: 1px;
  text-align: center;
  white-space: nowrap;
  /* 兜底色 */
  color: rgba(232, 232, 232, 0.8);
}

/* 折叠状态：图标 */
.fm-logo-min {
  width: 32px;
  height: 32px;
  display: block;
  object-fit: contain;
}

.w250 {
  width: 250px;
  padding: 0 20px;
}

.w65 {
  width: 40px;
  background-color: #f3f3f3;
}
</style>

<!--
  主题色适配（全局样式）：
  5 种预设主题色中 #A1CCF4 为浅色背景，其余为深色背景。
  通过 html[data-theme] 属性切换前景色，确保所有主题下标题对比度清晰。
  class 名带 fm- 前缀避免与其它组件冲突。
-->
<style lang="scss">
/* 深色主题：银色金属质感渐变（180deg 模拟金属圆柱反光）+ drop-shadow 高光 */
html[data-theme='dark'] .fm-brand-title {
  background: linear-gradient(
    180deg,
    #ffffff 0%,
    #efefef 22%,
    #b8b8b8 50%,
    #efefef 78%,
    #ffffff 100%
  );
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: #ffffff;
  filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.35));
}

html[data-theme='dark'] .fm-brand-subtitle {
  color: rgba(220, 220, 220, 0.85);
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.3);
}

/* 浅色主题（#A1CCF4 等）：深蓝金属质感渐变 + drop-shadow 高光 */
html[data-theme='light'] .fm-brand-title {
  background: linear-gradient(
    180deg,
    #4f7cff 0%,
    #205FE7 50%,
    #143071 100%
  );
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: #143071;
  filter: drop-shadow(0 1px 1px rgba(20, 48, 113, 0.2));
}

html[data-theme='light'] .fm-brand-subtitle {
  color: rgba(20, 48, 113, 0.82);
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.4);
}
</style>
